import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT, SERVICES } from "@/data/content";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [services, setServices] = useState(SERVICES);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/content", { params: { _: Date.now() } });
      setContent({ ...DEFAULT_CONTENT, ...r.data });
    } catch (e) { /* keep last known content */ }
    try {
      const s = await api.get("/services", { params: { _: Date.now() } });
      if (s.data?.length) setServices(s.data);
    } catch (e) { /* keep last known services */ }
    setLoaded(true);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Gate rendering until the current DB state has loaded, so the public site
  // never briefly renders stale/default media before the real data arrives.
  return (
    <ContentContext.Provider value={{ content, services, refresh, loaded }}>
      {loaded ? children : <div className="fixed inset-0 bg-[#F5F3EC]" data-testid="content-loading" />}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
